import AbstractScheduler from './AbstractScheduler';
import Token from './Token';
import { PropertyPriority } from '../../core/Constant';
import qs from 'qs';
import { PlayerEvent } from '../../PlayerEvents';
import log from 'loglevel';

/**
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */


/**
 * 回放调度策略
 *
 * @export
 * @class VodScheduler
 * @extends {AbstractScheduler}
 */
export default class VodScheduler extends AbstractScheduler {
  constructor() {
    super();
  }


  resolveData(data) {
    if (+data.code !== 200) {
      this.player.emit2All(PlayerEvent.SCHEDULER_FAIL, { code: 1, message: '获取直播状态码不为200' });
      log.error(`获取直播状态码不为200，状态码为:${data.code}`);
      return;
    }
    this.player.emit2All(PlayerEvent.SCHEDULER_SUCCESS, { code: 0, message: 'success' });
    // 创建token
    let token = new Token();
    token.player = this.player;
    token.create(data['data']['token']);

    let obj = null;
    let key = '';
    switch (this.type) {
      case 'native':
        obj = data['data']['mp4_domainnames'];
        key = 'mp4_domainname';
        break;
      case 'hls':
        obj = data['data']['hls_domainnames'];
        key = 'hls_domainname';
        break;
      default:
        log.warn(`暂时不支持${this.type}类型的点播`);
        return;
    }

    if (!obj) {
      return;
    }

    let allSupportDef = Object.keys(obj);
    if (allSupportDef.length < 1) {
      log.error('error', '无清晰度可用');
      return;
    }
    let lineCount = obj[allSupportDef[0]].length;
    let defs = [];
    while (lineCount) {
      defs.push([]);
      lineCount -= 1;
    }

    Object.keys(obj).forEach(item => {
      Object.values(obj[item]).forEach((subItem, index) => {
        let def = {
          idx: index,
          // url: 'http://127.0.0.1:9090/videos/1.mp4', // subItem[key],
          url: subItem[key],
          line: subItem['line'],
          def: item,
          cdnName: subItem['cdn_name']
        };

        defs[index].push(def);
      });
    });

    log.info(`整理点播清晰度完成,有${defs.length}条线路, ${defs.length > 0 ? defs[0].length : 0}个清晰度`);
    this._defineProperty(defs);
  }

  _defineProperty(defs) {
    let allDefinitionList = defs;
    let currentDefinitionListIndex = 0; // 默认选中第一个线路
    let currentDefinitionList = defs[currentDefinitionListIndex] || []; // 当前清晰度列表
    currentDefinitionList = currentDefinitionList.sort((a, b) => PropertyPriority[a.def] - PropertyPriority[b.def]);
    
    // 决策将要播放的清晰度地址
    let currentDefinition;
    if (currentDefinitionList.length == 0) {
      log.error("调度无法获取点播播放地址！")
      return;
    } else if (currentDefinitionList.length == 1) {
      currentDefinition = currentDefinitionList[0];
    } else {
      let defaultDef = this.option['defaultDef'];
      let defaultDefList = currentDefinitionList.filter(item => {
        return item.def === defaultDef;
      });

      if(defaultDefList.length > 0) {
        // 如有匹配清晰度，则使用
        currentDefinition = defaultDefList[0];
      } else {
        // 如无匹配清晰度，则优先寻找其他“非原画非音频”
        let alternatives = currentDefinitionList.filter(item => {
          return item.def !== 'same' && item.def !== 'a';
        });
        if (alternatives.length > 0) {
          currentDefinition = alternatives[0];
        } else {
          currentDefinition = currentDefinitionList[0];
        }
      }
    }

    let properties = {
      currentDefinitionListIndex,
      currentDefinitionList,
      allDefinitionList
    };
    for (const key in properties) {
      Object.defineProperty(this.player, key, {
        configurable: true,
        get: function () {
          return properties[key];
        },
        set: function (newValue) {
          properties[key] = newValue;
        }
      });
    }

    // 因为这个要派发事件，所以单独拿出来
    Object.defineProperty(this.player, 'currentDefinition', {
      configurable: true,
      get: function () {
        return currentDefinition;
      },
      set: function (newValue) {
        const e = {
          oldValue: currentDefinition,
          newValue
        };
        let { url: oldURL } = currentDefinition;
        let { url: newURL } = newValue;
        if (oldURL === newURL) {
          log.info('info', '新旧线路相同');
          // 某些情况下（拉流失败等），卡顿通过切换清晰度逻辑进行容错。故清晰度相同也切
          // return;
        }
        log.info('info', '切换线路');
        log.info('info', `old: ${currentDefinition.url}`);
        log.info('info', `new: ${newValue.url}`);
        currentDefinition = newValue;
        if (newValue.noSet) {
          delete newValue.noSet;
          return;
        }
        let token = this.newToken;
        let url = `${newValue.url}?token=${token}`;
        // 时移直播
        if (
          this._config.isLive &&
          this._config.isOpenTimeshift &&
          this._config.type === 'hls' &&
          this.player.getCdnName() === 'tx'
        ) {
          url = `${newValue.url}?delay=${this.player.delay}&token=${token}`;
        }

        // 点播记录换清晰度时的时间,用于判断是否向文档派发timeupdate事件
        if (!this._config.isLive && !this.player.vodPlayedTime) {
          this.player.vodPlayedTime = this.player.getCurrentTime();
        }
        this.player.setSrc(url).then(() => {
          this.player.vodPlayedTime && this.player.setCurrentTime(this.player.vodPlayedTime);
        });
        this.player.emit2All(PlayerEvent.DEFINITION_CHANGED, e);
      }
    });

    this.player.emit2All(PlayerEvent.SCHEDULER_COMPLETE);
    if (!this.readySeted) {
      this.player.emit2All(PlayerEvent.READY);
      this.readySeted = true;
    } else {
      this.player.emit2All(PlayerEvent.REFRESH_DISPATCH_COMPLETED);
    }
  }
}
